var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.phone)?_c('a',{staticClass:"btn btn-outline-dark mr-2",attrs:{"href":'tel:'+_vm.call}},[_c('i',{staticClass:"fa fa-phone"})]):_vm._e(),_vm._v(" "+_vm._s(_vm.phone)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }